export const generalCharts = {
  drawPie(id, echarts){
    let container = document.getElementById(id)
    let myChart = echarts.init(container)

    let chartDivWidthRaw = document.getElementById(id).style.width;
    let chartDivWidth = document.getElementById(id).querySelector('div').style.width;
    let chartWidth = (chartDivWidthRaw != undefined && chartDivWidthRaw != '') ? chartDivWidthRaw :
      (chartDivWidth != undefined && chartDivWidth != '') ? chartDivWidth : '200';
    let chartDivHeightRaw = document.getElementById(id).style.height;
    let chartDivHeight = document.getElementById(id).querySelector('div').style.height;
    let chartHeight = (chartDivHeightRaw != undefined && chartDivHeightRaw != '') ? chartDivHeightRaw :
      (chartDivHeight != undefined && chartDivHeight != '') ? chartDivHeight : '200';
    let width = (container.offsetWidth - 0) || chartWidth.replace('px', '');
    let height = (container.offsetHeight - 0) || chartHeight.replace('px', '');

    function getPointer(xPercent, yPercent) {
      return {
        x: xPercent * width,
        y: yPercent * height
      }
    }

    /**
     * 获取多边形的点
     * @type {{x, y}|*}
     */
    let cPointer1 = getPointer(0.32, 0.5)
    let cPointer2 = getPointer(0.75, 0.5)
    let radius1 = 84
    let radius2 = 100

    let point1 = [cPointer1.x, cPointer1.y - radius2]
    let point2 = [cPointer1.x, cPointer1.y + radius2]
    let point3 = [cPointer2.x, cPointer2.y + radius1]
    let point4 = [cPointer2.x, cPointer2.y - radius1]
    let points = [point1, point2, point3, point4]


    let legendData = ['优等地', '高等地', '中等地', '低等地']
    let titleWidth = width * 0.75 - 12 * 3 / 2
    let titleHeight = height * 0.18
    let rightPieDatas = [50, 40, 25, 35]
    let pieSeries = []
    let rightColors = ['#0f6d5f', '#29b29d', '#209c89', '#1a8373']
    legendData.map(function (item, idx) {
      let base = idx * 4
      let arr = []
      rightPieDatas.map(function (val, index) {
        arr.push({
          name: (index === 0 ? (index + 1 + base) : (4 - index + 1 + base)) + '等',
          value: val - index - idx * 2,
          itemStyle: {
            color: rightColors[index]
          }
        })
      })
      pieSeries.push(arr)
    })

    let option = {
      backgroundColor: '#002624',
      title: {
        text: legendData[1],
        x: titleWidth,
        y: titleHeight,
        textStyle: {
          color: '#31bea8',
          fontSize: '12'
        }
      },
      tooltip: {
        show: true,
        backgroundColor: '#002624',
        borderWidth: '1px',
        borderColor: 'rgba(0, 255, 238, 0.5)'
      },
      legend: {
        x: 'center',
        y: 'bottom',
        data: legendData,
        show: false
      },
      graphic: [
        {
          type: 'polygon',
          z: -100,
          shape: {
            points: points
          },
          style: {
            fill: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
              offset: 0, color: 'rgba(1,36,34,0.3)'// 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(49,184,168,0.5)' // 100% 处的颜色
            }], false)
          }
        }
      ],
      color: ['#31bea8', '#32a1ec', '#e8d63d', '#ea8f42'],
      calculable: true,
      series: [
        {
          type: 'pie',
          radius: [30, 100],
          center: ['32%', '50%'],
          label: {
            textStyle: {
              color: '#fff'
            },
            formatter: function (val) {
              return val.name + '\n' + val.percent + "%"
            }
          },
          labelLine: {
            show: false
          },
          startAngle: 84,
          data: [
            {value: 150, name: '优等地'},
            {value: 135, name: '高等地'},
            {value: 115, name: '中等地'},
            {value: 112, name: '低等地'}
          ]
        },
        {
          type: 'pie',
          radius: [0, 30],
          center: ['32%', '50%'],
          labelLine: {
            show: false
          },
          tooltip: {
            show: false
          },
          silent: true,
          animation: false,
          label: {
            show: false
          },
          data: [
            {
              value: 0, itemStyle: {
              color: '#083d35'
            }
            },
            {
              value: 1, itemStyle: {
              color: '#083d35'
            }
            }],
          z: 100
        },
        {
          type: 'pie',
          radius: [0, 84],
          center: ['75%', '50%'],
          data: [
            {
              value: 0, itemStyle: {
              color: '#083d35'
            }
            },
            {
              value: 1, itemStyle: {
              color: '#083d35'
            }
            }
          ],
          tooltip: {
            show: false
          },
          silent: true,
          animation: false,
          label: {
            show: false
          }
        },
        {
          name: legendData[1],
          type: 'pie',
          radius: [30, 70],
          center: ['75%', '50%'],
          startAngle: 70,
          data: [
            {
              value: 50, name: '5等', itemStyle: {
              color: '#0f6d5f'
            }
            },
            {
              value: 40, name: '8等', itemStyle: {
              color: '#29b29d'
            }
            }, {
              value: 25, name: '7等', itemStyle: {
                color: '#209c89'
              }
            },
            {
              value: 35, name: '6等', itemStyle: {
              color: '#1a8373'
            }
            }

          ],
          label: {
            textStyle: {
              color: '#fff'
            },
            position: 'inside',
            formatter: function (val) {
              return val.name + '\n' + val.percent + "%"
            }
          }
        }
      ]
    };
    myChart.setOption(option)
    myChart.on('click', function (params) {
      let seriesType = params.seriesType
      if (seriesType === 'pie' && params.seriesIndex === 0 && option.title.text !== params.name) {
        option.title.text = params.name
        option.series[3].name = params.name
        option.series[3].data = pieSeries[params.dataIndex]
        myChart.setOption(option)
      }
    })

    return myChart
  },
  drawBarLine(id, echarts){
    let myChart = echarts.init(document.getElementById(id))

    let legendData = ['优等地', '高等地', '中等地', '低等地', '增长率']
    let xAxisData = ['月湖区', '信江新区', '贵溪市', '余江县']
    let axisNameTextStyle = {
      color: '#99ffcc',
      fontFamily: 'MicrosoftYaHei',
      fontSize: '12px'
    };

    let colors = [{start: '#20ffc8', end: '#1ac7ac'}, {start: '#43baff', end: '#21a8f7'},
      {start: '#f7e22e', end: '#d3bf16'}, {start: '#ffc63c', end: '#dd9023'}]

    let lColors = colors.map(function (item) {
      return new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
        offset: 0, color: item.start// 0% 处的颜色
      }, {
        offset: 1, color: item.end // 100% 处的颜色
      }], false)
    })
    let datas = [[40, 34, 20, 201], [70, 58, 20, 102], [34, 69, 37, 112], [47, 104, 213, 167], [80, 123, 120, 59],
      [0.154 * 2, 0.244 * 2, 0.289 * 2, 0.316 * 2]];

    let seriesData = [];
    datas.map(function (item, index) {
      if (index === datas.length - 1) {
        let item = {
          name: legendData[4],
          yAxisIndex: 1,
          type: 'line',
          data: datas[index],
          symbol: 'circle',
          itemStyle: {
            color: '#ff6000',
            borderColor: '#eccf3e',
            borderWidth: '2'
          },
          symbolSize: 10
        }
        seriesData.splice(0, 1, item)
      } else {
        let item = {
          name: legendData[index - 1],
          type: 'bar',
          barWidth: 20,
          stack: '总量',
          data: datas[index]
        }
        seriesData.push(item)
      }

    })

    let dataZoomStart = 10
    let dataZoomEnd = 90
    let option = {
      color: lColors,
      backgroundColor: '#002624',
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          shadowStyle: {
            color: '#086862',
            opacity: 0.35
          }
        },
        backgroundColor: '#002624',
        borderWidth: '1px',
        borderColor: 'rgba(0, 255, 238, 0.5)',
        formatter: function (data) {
          let name = data[0].name
          let hint = '<div style="color:#fff;text-align:center;line-height:16px;height:18px;">' + name + '</div>'
          let subHint = ''
          let sum = 0;
          for (let i = 0; i < data.length; i++) {
            let seriesName = i !== 0 ? (data[i].seriesName + '面积') : ('同比' + data[i].seriesName)
            let value = data[i].value;
            let unit = '(万亩)';
            if (i == 0) {
              value = value * 100
              unit = '%'
            } else {
              sum += value
            }
            let item = '<span style="color:#cccccc;">' + seriesName + ':\t<span style="color:#4cd5ff">' + value + unit + '</span></span>'
            subHint += (item + '<br>')
          }
          let sumHint = '<span style="color:#cccccc;">耕地总面积' + ':\t<span style="color:#4cd5ff">' + sum + '(万亩)</span></span><br>'
          return hint + sumHint + subHint
        }
      },
      legend: {
        data: legendData,
        itemWidth: 7,
        itemHeight: 2,
        textStyle: {
          color: '#ffffff'
        }
      },
      xAxis: [
        {
          type: 'category',
          data: xAxisData,
          axisPointer: {
            type: 'shadow'
          },
          axisLabel: {
            color: '#fff'
          },
          axisLine: {
            lineStyle: {
              color: '#00eaff'
            }
          },
          axisTick: {
            show: false
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '耕地面积：万亩',
          nameTextStyle: axisNameTextStyle,
          min: 0,
          axisLabel: {
            color: '#fff'
          },
          axisLine: {
            lineStyle: {
              color: '#00eaff'
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        {
          type: 'value',
          name: '增长率 (%)',
          nameTextStyle: axisNameTextStyle,
          min: 0,
          axisLabel: {
            formatter: function (val) {
              return val * 100 + '%'
            },
            color: '#fff'
          },
          axisLine: {
            lineStyle: {
              color: '#00eaff'
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        }
      ],
      dataZoom: [
        {
          type: 'inside',
          xAxisIndex: [0],
          start: dataZoomStart,
          end: dataZoomEnd
        },
        {
          bottom: 10,
          type: 'slider',
          show: true,
          xAxisIndex: [0],
          start: dataZoomStart,
          end: dataZoomEnd,
          fillerColor: '#2cc0b6',
          backgroundColor: '#002624',
          height: 10,
          borderRadius: '7px',
          borderColor: '#23a199',
          textStyle: {
            color: 'transparent'
          },
          handleSize: '150%',
          handleStyle: {
            color: 'transparent'
          }
        }
      ],
      series: seriesData
    };
    myChart.setOption(option)

    return myChart
  }
}



// WEBPACK FOOTER //
// ./src/visus/generalCharts.js